import { supabase } from '../lib/supabaseClient';
import { SeoReport } from './seoTypes';

const API_BASE = (process.env.REACT_APP_PAPERMAN_API_URL || 'http://localhost:3001').replace(/\/$/, '');

async function call(path: string, method: 'GET' | 'POST'): Promise<SeoReport> {
    const session = await supabase.auth.getSession();
    const resp = await fetch(`${API_BASE}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${session.data.session?.access_token}`,
        },
    });
    if (!resp.ok) {
        let detail = '';
        try {
            const body = await resp.json();
            detail = body?.message || body?.error || '';
        } catch {
            // non-JSON error body
        }
        throw new Error(detail || `Request failed (${resp.status})`);
    }
    return resp.json();
}

/** Fetch the cached organic-search report (built on first request / when stale). */
export const fetchSeoReport = (): Promise<SeoReport> => call('/seo-report', 'GET');

/** Force a fresh pull from Google and return the rebuilt report. */
export const refreshSeoReport = (): Promise<SeoReport> => call('/seo-report/refresh', 'POST');

/** Generate the AI organic-insights action brief from a compact payload. */
export async function fetchSeoInsights(
    monthLabel: string,
    data: Record<string, unknown>,
): Promise<string> {
    const session = await supabase.auth.getSession();
    const resp = await fetch(`${API_BASE}/seo-report/insights`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${session.data.session?.access_token}`,
        },
        body: JSON.stringify({ month_label: monthLabel, data }),
    });
    if (!resp.ok) {
        let detail = '';
        try {
            const body = await resp.json();
            detail = body?.message || body?.error || '';
        } catch {
            // non-JSON error body
        }
        throw new Error(detail || `Request failed (${resp.status})`);
    }
    const body = (await resp.json()) as { summary?: string };
    return body.summary || '';
}
